import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { googleDriveFindFolder } from 'sprites-types/workflow/tools/googleDriveFindFolder'
import { MarkdownResult } from '../shared/MarkdownResult'
import { SchemaValidationError } from '../shared/safeParseToolResult'

interface Props {
  nodeExecution: NodeExecution
}

export function GoogleDriveFindFolderDisplay({ nodeExecution }: Props) {
  const schema = getToolResultSchema(googleDriveFindFolder, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data

  return <MarkdownResult data={result} title="Google Drive: Find Folder" />
}
